// extracted by mini-css-extract-plugin
export default {"root":"FBUr4D","hour-minutes-container":"IRLu7r","hour-minutes-input":"BVQ2HR","checkbox-container":"nmQD8h","input-container":"Ap8XTf","label":"RVAk1z","legend-hidden":"vZdWz3"};